import { StyleSheet } from 'react-native';

const CLOSE_BUTTON_ICON_SIZE = 16;
const BUTTON_SIZE = 40;

const styles = StyleSheet.create({
    root: {
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
    },
    buttons: {
        position: 'absolute',
        top: 0,
        right: (CLOSE_BUTTON_ICON_SIZE - BUTTON_SIZE) / 2,
        flexDirection: 'row',
        alignItems: 'center',
    },
    airPlayIcon: {
        width: 24,
        height: 24,
        marginBottom: 10,
    },
    closeButton: {
        width: BUTTON_SIZE,
        height: BUTTON_SIZE,
    },
    closeSvg: {
        width: CLOSE_BUTTON_ICON_SIZE,
        height: CLOSE_BUTTON_ICON_SIZE,
    },
});

export default styles;
